import Folder from '@clearkit/icons/glyphs/Folder';
import { CKSelect } from 'clearkit';

function CollectionSelect({ value, onChange, error, collections }) {
  const items = collections.map((collection) => ({
    label: collection.name,
    value: collection.id,
  }));

  const selectedItem = items.find((collection) => collection.value === value);

  return (
    <CKSelect
      isRequired
      id="collection"
      variant={error && 'error'}
      placeholder="Select collection"
      itemToString={(item) => item.label}
      items={items}
      selectedItemRenderer={(collection) => {
        return (
          <div className="flex items-center space-x-2">
            <Folder className="text-gray-400 fill-current" />
            <span>{collection.label}</span>
          </div>
        );
      }}
      selectedItem={selectedItem}
      onSelectedItemChange={(changes) => onChange(changes.selectedItem.value)}
    />
  );
}

CollectionSelect.propTypes = {
  onChange: PropTypes.func,
  collections: PropTypes.array,
  value: PropTypes.number,
  error: PropTypes.bool,
};

CollectionSelect.defaultProps = {
  error: false,
};

export default CollectionSelect;
